const hasFrom = (val) => val && (typeof val === 'object') && val._from;

export default hasFrom;
